// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.publications { 
  background: #ffffff; 
  padding: 60px 0;
}

.pub-list { 
  list-style: none; 
  display: grid; 
  grid-template-columns: 1fr; 
  gap: 20px; 
  margin: 0;
  padding: 0;
}

.pub-item { 
  background: #fff; 
  border: 1px solid #edf2f7; 
  border-radius: 12px; 
  padding: 20px 24px; 
  box-shadow: 0 6px 18px rgba(0,0,0,.05);
  position: relative;
  transition: all 0.3s ease;
}

.pub-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0,0,0,.1);
  border-color: #cbd5e0;
}

.pub-type-badge {
  display: inline-block;
  background: linear-gradient(135deg, #9e2536 0%, #c73951 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  position: absolute;
  top: 16px;
  right: 20px;
}

.pub-title { 
  margin-bottom: 10px; 
  margin-top: 0;
  font-size: 1.15rem; 
  color: #2d3748; 
  font-weight: 600;
  line-height: 1.4;
  padding-right: 80px; /* Space for badge */
}

.pub-authors { 
  color: #4a5568; 
  font-size: 0.9rem; 
  margin-bottom: 8px;
  line-height: 1.5;
}

.pub-venue {
  color: #718096;
  font-size: 0.85rem;
  font-style: italic;
  margin: 0;
}

.show-more-container {
  text-align: center;
  margin-top: 40px;
}

.show-more-btn {
  background: linear-gradient(135deg, #9e2536 0%, #c73951 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 25px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(158, 37, 54, 0.3);
}

.show-more-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(158, 37, 54, 0.4);
  background: linear-gradient(135deg, #8a1e2b 0%, #b02e43 100%);
}

.show-more-btn:active {
  transform: translateY(0);
}

/* Responsive design */
@media (max-width: 768px) {
  .pub-item {
    padding: 16px 20px;
  }
  
  .pub-type-badge {
    position: static;
    margin-bottom: 12px;
    display: block;
    width: fit-content;
  }
  
  .pub-title {
    padding-right: 0;
    font-size: 1.05rem;
  }
  
  .show-more-btn {
    padding: 10px 24px;
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Publications.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB,EAAE,oBAAoB;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,6DAA6D;AAC/D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":[".publications { \n  background: #ffffff; \n  padding: 60px 0;\n}\n\n.pub-list { \n  list-style: none; \n  display: grid; \n  grid-template-columns: 1fr; \n  gap: 20px; \n  margin: 0;\n  padding: 0;\n}\n\n.pub-item { \n  background: #fff; \n  border: 1px solid #edf2f7; \n  border-radius: 12px; \n  padding: 20px 24px; \n  box-shadow: 0 6px 18px rgba(0,0,0,.05);\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.pub-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(0,0,0,.1);\n  border-color: #cbd5e0;\n}\n\n.pub-type-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, #9e2536 0%, #c73951 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n  position: absolute;\n  top: 16px;\n  right: 20px;\n}\n\n.pub-title { \n  margin-bottom: 10px; \n  margin-top: 0;\n  font-size: 1.15rem; \n  color: #2d3748; \n  font-weight: 600;\n  line-height: 1.4;\n  padding-right: 80px; /* Space for badge */\n}\n\n.pub-authors { \n  color: #4a5568; \n  font-size: 0.9rem; \n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n.pub-venue {\n  color: #718096;\n  font-size: 0.85rem;\n  font-style: italic;\n  margin: 0;\n}\n\n.show-more-container {\n  text-align: center;\n  margin-top: 40px;\n}\n\n.show-more-btn {\n  background: linear-gradient(135deg, #9e2536 0%, #c73951 100%);\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 25px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(158, 37, 54, 0.3);\n}\n\n.show-more-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(158, 37, 54, 0.4);\n  background: linear-gradient(135deg, #8a1e2b 0%, #b02e43 100%);\n}\n\n.show-more-btn:active {\n  transform: translateY(0);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .pub-item {\n    padding: 16px 20px;\n  }\n  \n  .pub-type-badge {\n    position: static;\n    margin-bottom: 12px;\n    display: block;\n    width: fit-content;\n  }\n  \n  .pub-title {\n    padding-right: 0;\n    font-size: 1.05rem;\n  }\n  \n  .show-more-btn {\n    padding: 10px 24px;\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
